module.exports = __webpack_public_path__ + "static/media/myaccount-2.20c0e848.png";